import React, { Component } from 'react';

class Table extends Component {
  render() {
    return (
      <table className="table-auto w-full">
        {this.props.children}
      </table>
    );
  }

}

export default Table;
